import { render, staticRenderFns } from "./methodPriceDetail.vue?vue&type=template&id=952c925a&scoped=true&"
import script from "./methodPriceDetail.vue?vue&type=script&lang=js&"
export * from "./methodPriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./methodPriceDetail.vue?vue&type=style&index=0&id=952c925a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952c925a",
  null
  
)

export default component.exports